import React from 'react';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import Box from '@material-ui/core/Box';
import { t } from 'ttag';
import FormControl from '@material-ui/core/FormControl';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Chip from '@material-ui/core/Chip';
import PictureAsPdf from '@material-ui/icons/PictureAsPdf';
import Link from '@material-ui/core/Link';
import FormGroup from '@material-ui/core/FormGroup';
import useReactRouter from 'use-react-router';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import Timeline from '@material-ui/lab/Timeline';
import TimelineItem from '@material-ui/lab/TimelineItem';
import TimelineSeparator from '@material-ui/lab/TimelineSeparator';
import TimelineConnector from '@material-ui/lab/TimelineConnector';
import TimelineContent from '@material-ui/lab/TimelineContent';
import TimelineDot from '@material-ui/lab/TimelineDot';
import TimelineOppositeContent from '@material-ui/lab/TimelineOppositeContent';
import NewForm from '../../../components/NewForm';
import moment from 'moment';
import { useLazyQuery, useMutation, useQuery } from '@apollo/react-hooks';

import ParentsListView from './ParentsListView';

import FormField from '../../../components/FormField';
import Loading from '../../../components/Loading';
import FormBox from '../../../components/FormBox';
import ErrorMessage from '../../../components/ErrorMessage';
import UploadFiles from '../../../components/UploadFile';

import useEditForm from '../../../hooks/useEditForm';
import useCreateForm from '../../../hooks/useCreateForm';
import useUser from '../../../auth/hooks';
import useApi from '../../../api';
import {
  formatDateTime,
  formatPublicDate,
  toTitleCase,
  transliterate,
} from '../../../utils/helpers';
import {
  BASE_STATUS_TITLES,
  GENDER_OPTIONS,
  QUALIFICATION_OPTIONS,
  USER_STATUS,
  USER_TYPE_OPTIONS,
} from '../../../utils/enums';
import {
  canChangeTrainerForAthlete,
  isManager,
  isSuperManager,
  isTrainer,
} from '../../../utils/permissions';
import useNotifier from '../../../components/Messages/hooks';
import DataTable from '../../../components/DataTable';
import AddContributionDialog from '../../../components/ContributionDialog';
import ImageCropper from '../../../components/ImageCropper';
import LoadingButton from '../../../components/LoadingButton';
import { useNavigator } from '../../../components/Navigator';
import { ERROR_MESSAGES, extractDataError } from '../../../utils/errors';
import ActivityChangesTable from '../components/ActivityChangesTable';
import { AddGroupModalController } from '../components/AddGroupModal';
import { TabPanel, useTabs } from '../../../components/Tab/Tabs';
import { ReasonDialogForm } from '../components/ReasonDialog';
import { FoundUserDialog } from '../components/FoundUserDialog';
import { CyrillicTooltiop } from '../components/Tooltips';
import * as Yup from 'yup';
import Dialog from '@material-ui/core/Dialog';
import AthleteGroupChangeDialog from '../../../components/AthleteGroupChangeDialog';
import useRouter from 'use-react-router';

const TABS = {
  info: 0,
  addition: 1,
  activities: 2,
};

const AddtitoinTab = ({ objectId, athlete, onTrainersChanged }) => {
  const { user: authUser } = useUser();
  const api = useApi();
  const pushMessage = useNotifier();
  const [state, setState] = React.useState({
    userTypes: athlete.types,
    isOpen: false,
    contribution: null,
    changeAthleteGroup: null,
  });
  const { loading, data, refetch } = useQuery(api.schema.groups.many()[0], {
    variables: { inputFilter: { athleteId: objectId } },
    fetchPolicy: 'network-only',
  });
  const {
    loading: contributionLoading,
    data: contributionData,
    refetch: contributionRefetch,
  } = useQuery(api.schema.contributions.many()[0], {
    fetchPolicy: 'network-only',
    variables: { inputFilter: { userId: objectId } },
  });

  const [doSetUserTypes] = useMutation(api.schema.athletes.setUserTypes()[0], {
    onCompleted: (d) => {
      const res = d[api.schema.athletes.setUserTypes()[1]];
      if (res.ok) {
        pushMessage({ text: 'Успішно змінено роль користувача' });
      }
    },
  });

  const [doDelete] = useMutation(api.schema.contributions.delete()[0], {
    onCompleted: (d) => {
      const res = d[api.schema.contributions.delete()[1]];
      if (res.ok) {
        pushMessage({ text: 'Успішно видалено' });
        contributionRefetch();
      }
    },
  });

  const handleOnDelete = (data) => {
    doDelete({ variables: { id: data.id } });
    contributionRefetch();
  };

  const handleOnUpdate = (contribution) => {
    setState({
      ...state,
      isOpen: true,
      isOpenList: false,
      contribution,
    });
    contributionRefetch();
  };

  const handleOnAdd = () => {
    setState({ ...state, isOpen: true, contribution: null });
  };

  const handleOnCreate = () => {
    setState({ ...state, isOpen: false, contribution: null });
    contributionRefetch();
  };

  const handleChangeTypes = (e, userTypeId) => {
    let userTypes = [];
    if (e.target.checked) {
      userTypes = state.userTypes.concat(userTypeId);
    } else {
      userTypes = state.userTypes.filter((t) => t !== userTypeId);
    }
    doSetUserTypes({ variables: { id: athlete.id, inputData: { userTypes } } });
    setState({ ...state, userTypes });
  };

  const onClickChangeGroup = (e, data) => {
    setState({ ...state, changeAthleteGroup: data });
  };

  const [updateGroup] = useMutation(api.schema.athletes.changeGroup()[0], {
    onCompleted: (d) => {
      const { updateAthleteGroup: res } = d;
      if (res.ok) {
        pushMessage({ text: 'Успішно переведено в іншу групу' });
        const newState = {
          ...state,
          changeAthleteGroup: null,
        };
        setState(newState);
        refetch();
        onTrainersChanged();
      } else {
        const dataError = extractDataError(res.errors);
        pushMessage({ text: dataError });
      }
    },
  });

  const onHandleChangeGroup = (newGroupId) => {
    updateGroup({
      variables: {
        athleteId: athlete.id,
        fromGroupId: state.changeAthleteGroup.id,
        toGroupId: newGroupId,
      },
    });
  };

  if (loading || contributionLoading) {
    return <Loading />;
  }

  const columns = [
    { title: t`Id`, field: 'id', editable: 'never' },
    {
      title: t`Назва`,
      field: 'name',
      render: (r) => {
        return (
          <Link target='_blank' href={api.router.groups.edit(r.id)}>
            {r.name}
          </Link>
        );
      },
    },
    {
      title: t`Вид спорту`,
      field: 'section',
      render: ({ sectionObj }) => (sectionObj && sectionObj.name) || '',
    },
    {
      title: t`Зал`,
      field: 'gym_id',
      render: ({ gym }) => (gym && gym.name) || '',
    },
    {
      title: t`Тренер`,
      field: 'trainer',
      render: ({ trainer }) => {
        return (
          <Link target='_blank' href={api.router.trainers.edit(trainer.id)}>
            {trainer.fullName}
          </Link>
        );
      },
    },
    { title: t`Спортсменів`, field: 'countAthletes' },
    {
      title: t`Статус`,
      field: 'status',
      render: ({ status }) => BASE_STATUS_TITLES[status],
    },
  ];

  return (
    <Grid container>
      <Grid item sm={12}>
        {authUser.isAdmin && (
          <FormBox title={t`Роль користувача`}>
            <FormGroup row>
              {USER_TYPE_OPTIONS.map((userType) => (
                <FormControlLabel
                  key={userType.id}
                  control={
                    <Switch
                      checked={state?.userTypes?.includes(userType.id)}
                      onChange={(e) => handleChangeTypes(e, userType.id)}
                      color='primary'
                    />
                  }
                  label={userType.label}
                />
              ))}
            </FormGroup>
          </FormBox>
        )}
      </Grid>
      <Grid item sm={12} style={{ marginTop: '20px' }}>
        <DataTable
          isLoading={loading}
          title={t`Список групп`}
          pageSize={5}
          columns={columns}
          data={data ? data.groups : []}
          onChangeGroup={
            authUser.isAdmin || authUser.isSuperManager
              ? onClickChangeGroup
              : undefined
          }
        />
      </Grid>
      <Grid item sm={12} style={{ marginTop: '20px' }}>
        {state.isOpen && (
          <AddContributionDialog
            trainerId={athlete.mainTrainerId}
            user={athlete}
            open={state.isOpen}
            contribution={state.contribution}
            toggle={(v) => setState({ isOpen: v })}
            onSubmit={handleOnCreate}
            userIds={[]}
          />
        )}
        <DataTable
          isLoading={loading}
          title='Членскі внески'
          pageSize={5}
          columns={[
            { title: t`Id`, field: 'id', editable: 'never' },
            {
              title: t`Тренер`,
              field: 'trainer',
              editable: 'never',
              render: ({ trainer }) => {
                return (
                  <Link
                    target='_blank'
                    href={api.router.trainers.edit(trainer.id)}
                  >
                    {trainer.fullName}
                  </Link>
                );
              },
            },
            {
              title: t`Зал`,
              field: 'gym',
              editable: 'never',
              render: ({ gym }) => {
                return (
                  <Link target='_blank' href={api.router.gyms.edit(gym.id)}>
                    {gym.name}
                  </Link>
                );
              },
            },
            { title: t`Рік`, field: 'year' },
            {
              title: t`Дата внеску`,
              field: 'addedAt',
              render: ({ addedAt }) => formatPublicDate(addedAt),
            },
            { title: t`Внесок`, field: 'amount' },
          ]}
          data={
            contributionData
              ? contributionData[api.schema.contributions.many()[1]]
              : []
          }
          onDelete={handleOnDelete}
          onAdd={handleOnAdd}
          customActions={[
            {
              icon: 'edit',
              tooltip: t`Редагувати внесок`,
              onClick: (event, rowData) => handleOnUpdate(rowData),
            },
          ]}
        />
      </Grid>
      {state.changeAthleteGroup && (
        <Dialog
          open={!!state.changeAthleteGroup}
          onClose={() => setState({ ...state, changeAthleteGroup: null })}
        >
          <AthleteGroupChangeDialog
            currentGroupId={state.changeAthleteGroup.id}
            handleChangeGroup={onHandleChangeGroup}
          />
        </Dialog>
      )}
    </Grid>
  );
};

const ActivityTab = ({ objectId }) => {
  const api = useApi();
  const { loading, data } = useQuery(api.schema.activities.many()[0], {
    variables: { inputFilter: { objectId, objectType: 'athlete' } },
    fetchPolicy: 'no-cache',
  });

  if (loading) {
    return <Loading />;
  }
  return (
    <Grid container>
      <Grid item sm={8}>
        <Timeline>
          {data.activities.map((a, index) => (
            <TimelineItem key={index}>
              <TimelineOppositeContent>
                <Typography color='textSecondary'>
                  {formatDateTime(a.createdAt)}
                </Typography>
              </TimelineOppositeContent>
              <TimelineSeparator>
                <TimelineDot color='primary' />
                <TimelineConnector />
              </TimelineSeparator>
              <TimelineContent>
                <Paper elevation={3} style={{ padding: '5px' }}>
                  <Chip label={a.actor.name} variant='outlined' />
                  <br />
                  <br />
                  <b>{`${a.verb.name} `}</b>
                  <ActivityChangesTable changes={a.changes} />
                </Paper>
              </TimelineContent>
            </TimelineItem>
          ))}
        </Timeline>
      </Grid>
    </Grid>
  );
};

const BaseForm = ({
  initial,
  loading,
  edit,
  onSubmit,
  errors,
  showPasswordField,
  userId,
  athlete,
  onActivate,
  onBlock,
  onArchivate,
  refetchAthlete,
}) => {
  const { user } = useUser();
  const api = useApi();
  const [isReasonDialog, toggleReasonDialog] = React.useState(false);
  const [isArchiveReasonDialog, toggleReasonArhiveDialog] =
    React.useState(false);
  const [isAddToGroupDialog, setShowAddGroupDialog] = React.useState(false);
  const [isLoadingPdf, setLoadingPdf] = React.useState(false);
  const [toolTipMap, setToolTip] = React.useState({
    lastName: false,
    firstName: false,
    middleName: false,
  });
  const [foundAthlete, setFundAthlete] = React.useState(null);

  const [tab, onChangeTab] = useTabs({ tabs: TABS, defaultTab: TABS.info });
  const topRef = React.createRef();

  const [generateProfileInfo] = useMutation(
    api.schema.athletes.generateProfileInfo()[0],
    {
      onCompleted: (d) => {
        const res = d[api.schema.athletes.generateProfileInfo()[1]];
        if (res.ok) {
          setLoadingPdf(false);
          window.open(res.url, '_blank').focus();
        }
      },
    }
  );

  const [searchUser] = useLazyQuery(api.schema.athletes.many()[0], {
    fetchPolicy: 'network-only',
    onCompleted: (d) => {
      const res = d[api.schema.athletes.many()[1]];
      if (res.length > 0) {
        setFundAthlete(res[0]);
      }
    },
  });

  const handleChangeName = (e, data, setFields) => {
    const onlyCyrillic = e.target.value.replace(/[A-Za-z]+/gi, '');
    let lastNameLen = data.lastName.length;
    let firstNameLen = data.firstName.length;
    let middleNameLen = data.middleName.length;
    let { firstName } = data;
    let { lastName } = data;
    let { middleName } = data;
    if (e.target.name === 'lastName') {
      lastName = toTitleCase(onlyCyrillic).trim();
      lastNameLen = lastName.length;
      if (lastNameLen === 0) {
        setToolTip({ lastName: true });
        setTimeout(() => setToolTip({ lastName: false }), 3000);
      }
      setFields({
        ...data,
        [e.target.name]: lastName,
        enFullName: transliterate(
          [e.target.value, data.firstName || ''].join(' ')
        ).toUpperCase(),
      });
    } else if (e.target.name === 'firstName') {
      firstName = toTitleCase(onlyCyrillic).trim();
      firstNameLen = firstName.length;
      if (firstNameLen === 0) {
        setToolTip({ firstName: true });
        setTimeout(() => setToolTip({ firstName: false }), 3000);
      }
      setFields({
        ...data,
        [e.target.name]: firstName,
        enFullName: transliterate(
          [data.lastName || '', e.target.value].join(' ')
        ).toUpperCase(),
      });
    } else if (e.target.name === 'middleName') {
      middleName = toTitleCase(onlyCyrillic).trim();
      middleNameLen = middleName.length;
      if (middleNameLen === 0) {
        setToolTip({ middleName: true });
        setTimeout(() => setToolTip({ middleName: false }), 3000);
      }
      setFields({
        ...data,
        [e.target.name]: middleName,
      });
    }

    if (lastNameLen >= 3 && firstNameLen >= 3 && middleNameLen >= 3) {
      searchUser({
        variables: { inputFilter: { firstName, lastName, middleName } },
      });
    }
  };
  const handleOnSubmit = (formData) => {
    if (
      formData.firstName.length >= 3 &&
      formData.lastName >= 3 &&
      formData.middleName >= 3
    ) {
      searchUser({
        variables: {
          inputFilter: {
            firstName: formData.firstName,
            lastName: formData.lastName,
            middleName: formData.middleName,
          },
        },
      });
    }
    onSubmit(formData);
  };

  const validationSchema = Yup.object({
    lastName: Yup.string().required(),
    firstName: Yup.string().required(),
    middleName: Yup.string().required(),
    enFullName: Yup.string().required(),
    birthday: Yup.date().required().typeError(ERROR_MESSAGES.required),
    gender: Yup.number().required(),
    photo: Yup.object().required().typeError(ERROR_MESSAGES.required),
    email: Yup.string().email().required().typeError(ERROR_MESSAGES.required),
    address: Yup.string().required().typeError(ERROR_MESSAGES.required),
    groupId: edit
      ? null
      : Yup.number().required().typeError(ERROR_MESSAGES.required),
  });

  return (
    <>
      {foundAthlete && foundAthlete.id !== Number(userId) && (
        <FoundUserDialog
          open={!!foundAthlete}
          athlete={foundAthlete}
          onClose={() => setFundAthlete(null)}
        />
      )}

      <NewForm
        onSubmit={handleOnSubmit}
        initial={initial}
        errors={errors}
        validationSchema={validationSchema}
        onError={() => {
          topRef.current.scrollIntoView();
        }}
      >
        {({ formik, data, change, errors, submit, setFields }) => {
          // Formik won't reinitialize; without this a later save restores stale trainers.
          const syncTrainers = async () => {
            if (!refetchAthlete) return;
            const res = await refetchAthlete();
            const fresh = res && res.data && res.data.athlete;
            if (!fresh) return;
            formik.setFieldValue('trainerIds', fresh.trainerIds || []);
            formik.setFieldValue('mainTrainerId', fresh.mainTrainerId || null);
          };
          return (
            <>
              <Tabs
                ref={topRef}
                value={tab}
                indicatorColor='primary'
                textColor='primary'
                onChange={(e, v) => onChangeTab(v)}
              >
                <Tab label={t`Основна Інформація`} disabled={!edit} />
                <Tab label={t`Додатково`} disabled={!userId} />
                <Tab label={t`Історія`} disabled={!user.isAdmin || !userId} />
              </Tabs>
              <TabPanel value={tab} index={TABS.info}>
                <ReasonDialogForm
                  open={isReasonDialog}
                  onClose={() => toggleReasonDialog(false)}
                  onAccept={(data) => {
                    onBlock(data.reason, data.date);
                    toggleReasonDialog(false);
                  }}
                  showDateField
                />
                <ReasonDialogForm
                  open={isArchiveReasonDialog}
                  onClose={() => toggleReasonArhiveDialog(false)}
                  onAccept={(data) => {
                    onArchivate(data.reason);
                    toggleReasonArhiveDialog(false);
                  }}
                />
                {userId && isAddToGroupDialog && (
                  <AddGroupModalController
                    athleteId={userId}
                    onClose={() => setShowAddGroupDialog(false)}
                    onAccept={(res) => {
                      setShowAddGroupDialog(false);
                      onActivate(res);
                      if (res.ok) syncTrainers();
                    }}
                  />
                )}
                <Grid container spacing={4}>
                  <Grid item sm={6}>
                    <FormBox
                      title={
                        <Grid container>
                          <Grid item sm={8}>
                            <span>{t`Основна інформація`}</span>
                          </Grid>
                          {edit && (
                            <Grid item sm={4}>
                              <LoadingButton
                                loading={isLoadingPdf}
                                margin='normal'
                                type='button'
                                variant='outlined'
                                color='default'
                                size='small'
                                onClick={() => {
                                  setLoadingPdf(true);
                                  generateProfileInfo({
                                    variables: { id: athlete.id },
                                  });
                                }}
                              >
                                {t`Завантажити`}
                                <PictureAsPdf style={{ marginLeft: '5px' }} />
                              </LoadingButton>
                            </Grid>
                          )}
                        </Grid>
                      }
                    >
                      {user.isAdmin && (
                        <FormField
                          required
                          fullWidth
                          query={api.schema.clubs.many()[0]}
                          preInit
                          dataKey='clubs'
                          variables={{}}
                          type='remoteSelect'
                          margin='normal'
                          label={t`Оберіть клуб`}
                          id='clubId'
                          name='clubId'
                          variant='outlined'
                          value={data.clubId}
                          errors={errors.clubId}
                          labelKey='fullName'
                          onChange={(e) => {
                            if (e.target.value !== data.clubId) {
                              setFields({
                                ...data,
                                [e.target.name]: e.target.value,
                                trainerIds: [],
                              });
                            } else {
                              change(e);
                            }
                          }}
                        />
                      )}
                      <CyrillicTooltiop open={toolTipMap.lastName}>
                        <FormField
                          required
                          fullWidth
                          type='text'
                          margin='normal'
                          label={t`Прізвище`}
                          id='lastName'
                          name='lastName'
                          autoComplete='lastName'
                          variant='outlined'
                          value={data.lastName}
                          errors={errors.lastName}
                          onChange={(e) => handleChangeName(e, data, setFields)}
                        />
                      </CyrillicTooltiop>
                      <CyrillicTooltiop open={toolTipMap.firstName}>
                        <FormField
                          required
                          fullWidth
                          type='text'
                          margin='normal'
                          label={t`Ім'я`}
                          id='firstName'
                          name='firstName'
                          autoComplete='firstName'
                          variant='outlined'
                          value={data.firstName}
                          errors={errors.firstName}
                          onChange={(e) => handleChangeName(e, data, setFields)}
                        />
                      </CyrillicTooltiop>
                      <CyrillicTooltiop open={toolTipMap.middleName}>
                        <FormField
                          required
                          fullWidth
                          type='text'
                          margin='normal'
                          label={t`По-батькові`}
                          id='middleName'
                          name='middleName'
                          autoComplete='middleName'
                          variant='outlined'
                          value={data.middleName}
                          errors={errors.middleName}
                          onChange={(e) => handleChangeName(e, data, setFields)}
                        />
                      </CyrillicTooltiop>
                      <FormField
                        required
                        fullWidth
                        type='text'
                        margin='normal'
                        label={t`Прізвище Ім’я (Eng)`}
                        id='enFullName'
                        name='enFullName'
                        autoComplete='middleName'
                        variant='outlined'
                        value={data.enFullName}
                        errors={errors.enFullName}
                        onChange={(e) => {
                          setFields({
                            ...data,
                            [e.target.name]: e.target.value.replace(
                              / [^A-Za-z]/gi,
                              ''
                            ),
                          });
                        }}
                      />
                      <FormField
                        required
                        fullWidth
                        type='date'
                        margin='normal'
                        label={t`Дата народження`}
                        id='birthday'
                        name='birthday'
                        autoComplete='birthday'
                        variant='outlined'
                        value={data.birthday}
                        errors={errors.birthday}
                        onChange={change}
                      />
                      <FormField
                        required
                        fullWidth
                        type='select'
                        margin='normal'
                        label={t`Стать`}
                        id='gender'
                        name='gender'
                        autoComplete='gender'
                        variant='outlined'
                        value={data.gender}
                        errors={errors.gender}
                        options={GENDER_OPTIONS}
                        onChange={change}
                      />
                      <FormField
                        disabled={edit && !!data.rank}
                        fullWidth
                        query={api.schema.ranks.kyus()[0]}
                        preInit={edit}
                        dataKey={api.schema.ranks.kyus()[1]}
                        variables={{}}
                        type='remoteSelect'
                        margin='normal'
                        label={t`Оберіть кю`}
                        id='rank'
                        name='rank'
                        variant='outlined'
                        value={data.rank}
                        errors={errors.rank}
                        labelKey='name'
                        onChange={change}
                      />
                      <FormField
                        disabled={edit && !!data.rank}
                        fullWidth
                        query={api.schema.ranks.dans()[0]}
                        preInit={edit}
                        dataKey={api.schema.ranks.dans()[1]}
                        variables={{}}
                        type='remoteSelect'
                        margin='normal'
                        label={t`Оберіть дан`}
                        id='rank'
                        name='rank'
                        variant='outlined'
                        value={data.rank}
                        errors={errors.rank}
                        labelKey='name'
                        onChange={change}
                      />
                      <FormField
                        fullWidth
                        type='select'
                        margin='normal'
                        label={t`Спортивна кваліфікація`}
                        id='qualification'
                        name='qualification'
                        variant='outlined'
                        value={data.qualification}
                        errors={errors.qualification}
                        options={QUALIFICATION_OPTIONS}
                        onChange={change}
                      />
                      <FormField
                        required
                        fullWidth
                        disabled
                        query={api.schema.common.sections()[0]}
                        preInit={edit}
                        dataKey='sections'
                        variables={{}}
                        type='multi_select'
                        margin='normal'
                        label={t`Оберіть вид спорту`}
                        id='sections'
                        name='sections'
                        variant='outlined'
                        value={data.sections}
                        errors={errors.sections}
                        labelKey='name'
                        onChange={change}
                      />
                      {canChangeTrainerForAthlete(user) && (
                        <FormField
                          required
                          disabled
                          fullWidth
                          query={api.schema.trainers.many()[0]}
                          preInit={edit}
                          dataKey={api.schema.trainers.many()[1]}
                          variables={{
                            inputFilter: {
                              clubId: user.isAdmin ? data.clubId : user.clubId,
                              status: USER_STATUS.active,
                            },
                          }}
                          type='multi_select'
                          margin='normal'
                          label={t`Оберіть тренера`}
                          id='trainerIds'
                          name='trainerIds'
                          variant='outlined'
                          value={data.trainerIds}
                          errors={errors.trainer_ids}
                          labelKey='fullName'
                          onChange={(e) => {
                            if (e.target.value && e.target.value.length === 1) {
                              setFields({
                                ...data,
                                [e.target.name]: e.target.value,
                                mainTrainerId: e.target.value[0],
                              });
                            } else {
                              change(e);
                            }
                          }}
                          mainProps={{
                            title: t`Оберіть головного тренера:`,
                            value: data.mainTrainerId,
                            valueKey: 'id',
                            labelKey: 'fullName',
                            name: 'mainTrainerId',
                            onchange: change,
                          }}
                        />
                      )}
                      <FormField
                        fullWidth
                        type='text'
                        margin='normal'
                        label={t`WKF-ID`}
                        id='leagueId'
                        name='leagueId'
                        autoComplete='leagueId'
                        variant='outlined'
                        value={data.leagueId}
                        errors={errors.league_id}
                        onChange={change}
                      />
                      {data.leagueId && (
                        <Link
                          target='_blank'
                          href={`http://setopen.sportdata.org/wkfranking/ranking_main_competitor.php?ranking_country=UKR&ranking_competitor=${data.leagueId}&hidemenu=true`}
                          variant='body2'
                        >
                          {t`Перейти до статистики ${data.leagueId}`}
                        </Link>
                      )}
                      {showPasswordField && (
                        <FormField
                          required
                          fullWidth
                          type='password'
                          margin='normal'
                          label={t`Пароль`}
                          id='password'
                          name='password'
                          autoComplete='password'
                          variant='outlined'
                          value={data.password}
                          errors={errors.password}
                          onChange={change}
                        />
                      )}
                      {!edit && (
                        <FormField
                          required
                          fullWidth
                          disabled={user.isAdmin && !data.clubId}
                          query={api.schema.groups.many()[0]}
                          preInit={true}
                          dataKey={api.schema.groups.many()[1]}
                          variables={{}}
                          type='remoteSelect'
                          margin='normal'
                          label={t`Оберіть групу`}
                          id='groupId'
                          name='groupId'
                          variant='outlined'
                          value={data.groupId}
                          errors={errors.groupId}
                          getOptionLabel={(o) => {
                            return o
                              ? `${o.name} (${o.gym.name}/${o.sectionObj.name}/${o.trainer.fullInitials})`
                              : '';
                          }}
                          labelKey='name'
                          onChange={change}
                        />
                      )}
                    </FormBox>
                  </Grid>
                  <Grid item sm={6}>
                    <FormBox required grid title={t`Фото спортсмена *`}>
                      <FormControl
                        required
                        variant='outlined'
                        fullWidth
                        margin='normal'
                      >
                        <ImageCropper
                          name='photo'
                          objectType='user_photo'
                          onChange={change}
                          fileObject={data.photo}
                        />
                        <ErrorMessage errors={errors.photo} />
                      </FormControl>
                    </FormBox>
                    <FormBox title={t`Контактна інформація`}>
                      <FormField
                        required
                        fullWidth
                        type='text'
                        margin='normal'
                        label={t`Email`}
                        id='email'
                        name='email'
                        autoComplete='email'
                        variant='outlined'
                        value={data.email}
                        errors={errors.email}
                        onChange={change}
                      />
                      <FormField
                        fullWidth
                        type='text'
                        margin='normal'
                        label={t`Телефон`}
                        id='phone'
                        name='phone'
                        autoComplete='phone'
                        variant='outlined'
                        value={data.phone}
                        errors={errors.phone}
                        onChange={change}
                      />
                      <FormField
                        required
                        fullWidth
                        type='text'
                        margin='normal'
                        label={t`Адреса`}
                        id='address'
                        name='address'
                        autoComplete='address'
                        variant='outlined'
                        value={data.address}
                        errors={errors.address}
                        onChange={change}
                      />
                    </FormBox>
                    <FormBox title={t`Документи`}>
                      <UploadFiles
                        name='documentIds'
                        files={data.documentIds}
                        multiple
                        objectType='athlete_document'
                        onChange={change}
                      />
                    </FormBox>
                    {userId && (
                      <FormBox title={null}>
                        <ParentsListView userId={userId} />
                      </FormBox>
                    )}
                    <FormBox title={t`Атестації`}>
                      <Typography gutterBottom>{t`Данні відсутні`}</Typography>
                    </FormBox>
                  </Grid>
                  <Grid container spacing={2}>
                    <Grid item sm={4}>
                      <LoadingButton
                        loading={loading}
                        style={{ margin: '10px 0 20px 0' }}
                        variant='contained'
                        color='primary'
                        onClick={submit}
                      >
                        {t`Зберегти`}
                      </LoadingButton>
                    </Grid>
                    {athlete && (
                      <>
                        {user.isAdmin &&
                          athlete.status !== USER_STATUS.blocked && (
                            <Grid item sm={4}>
                              <Button
                                style={{ margin: '20px 0 20px 0' }}
                                margin='normal'
                                type='button'
                                fullWidth
                                variant='outlined'
                                color='secondary'
                                onClick={() => toggleReasonDialog(true)}
                              >
                                {t`Заблокувати`}
                              </Button>
                            </Grid>
                          )}
                        {/* TODO use permission */}
                        {(user.isAdmin ||
                          isManager(user) ||
                          isSuperManager(user)) &&
                          athlete.status !== USER_STATUS.active && (
                            <Grid item sm={4}>
                              <Button
                                style={{ margin: '20px 0 20px 0' }}
                                margin='normal'
                                type='button'
                                fullWidth
                                variant='outlined'
                                color='primary'
                                onClick={() => setShowAddGroupDialog(true)}
                              >
                                {t`Активувати`}
                              </Button>
                            </Grid>
                          )}
                        {/* TODO use permission */}
                        {(user.isAdmin ||
                          isManager(user) ||
                          isSuperManager(user) ||
                          isTrainer(user)) &&
                          athlete.status !== USER_STATUS.archived && (
                            <Grid item sm={4}>
                              <Button
                                style={{ margin: '20px 0 20px 0' }}
                                margin='normal'
                                type='button'
                                fullWidth
                                variant='outlined'
                                color='default'
                                onClick={() => toggleReasonArhiveDialog(true)}
                              >
                                {t`В архів`}
                              </Button>
                            </Grid>
                          )}
                      </>
                    )}
                  </Grid>
                </Grid>
              </TabPanel>
              <TabPanel value={tab} index={TABS.addition}>
                <AddtitoinTab
                  objectId={userId}
                  athlete={athlete}
                  onTrainersChanged={syncTrainers}
                />
              </TabPanel>
              <TabPanel value={tab} index={TABS.activities}>
                <ActivityTab objectId={userId} />
              </TabPanel>
            </>
          );
        }}
      </NewForm>
    </>
  );
};

const getInitialData = (row) => {
  return {
    clubId: row.clubId || null,
    firstName: row.firstName || '',
    lastName: row.lastName || '',
    middleName: row.middleName || '',
    email: row.email || '',
    gender: row.gender || undefined,
    photo: row.photo || null,
    enFullName: row.enFullName || '',
    phone: row.phone || '',
    address: row.address || null,
    rank: row.rank || '',
    birthday: row.birthday || null,
    trainerIds: row.trainerIds || [],
    documentIds: row.documentIds || [],
    qualification: row.qualification || '',
    leagueId: row.leagueId || '',
    sections: (row.sections && row.sections.map((r) => r.id || r)) || [],
    mainTrainerId: row.mainTrainerId || null,
    groupId: row.groupId || null,
  };
};

const getPostData = (row) => {
  return {
    clubId: Number(row.clubId) || null,
    firstName: row.firstName || '',
    lastName: row.lastName || '',
    middleName: row.middleName || '',
    email: row.email || '',
    gender: Number(row.gender) || null,
    photo: (row.photo && row.photo.id) || null,
    enFullName: row.enFullName || '',
    phone: row.phone || '',
    address: row.address || '',
    rank: row.rank || '',
    birthday:
      (row.birthday && moment(row.birthday).format('YYYY-MM-DD')) || null,
    trainerIds: row.trainerIds || [],
    documentIds: (row.documentIds && row.documentIds.map((r) => r.id)) || [],
    qualification: row.qualification || '',
    leagueId: row.leagueId || '',
    sections: row.sections && row.sections.map((r) => r.id || r),
    mainTrainerId: row.mainTrainerId || null,
    groupId: row.groupId || null,
  };
};

export const EditForm = () => {
  const navigate = useNavigator();
  const { location } = useReactRouter();
  const nextPage = new URLSearchParams(location.search).get('next');
  const pushMessage = useNotifier();
  const api = useApi();
  const { id, loading, submitLoading, data, onSubmit, errors, refetch } =
    useEditForm({
      schema: api.schema.athletes,
      router: api.router.athletes,
      onComplete: () => {
        pushMessage({ text: 'Успішно збережено' });
        if (nextPage) {
          navigate(nextPage);
        }
      },
    });

  const [blockAthlete] = useMutation(api.schema.athletes.block()[0], {
    onCompleted: (d) => {
      const { blockAthlete: res } = d;
      if (res.ok) {
        pushMessage({ text: 'Успішно заблоковано' });
        refetch();
      } else {
        const dataError = extractDataError(res.errors);
        pushMessage({ text: dataError });
      }
    },
  });

  const activateAthlete = (res) => {
    if (res.ok) {
      pushMessage({ text: 'Успішно активовано' });
      refetch();
    } else {
      const dataError = extractDataError(res.errors);
      pushMessage({ text: dataError });
    }
  };

  const [archivateAthlete] = useMutation(api.schema.athletes.archivate()[0], {
    onCompleted: (d) => {
      const { archivateAthlete: res } = d;
      if (res.ok) {
        pushMessage({ text: 'Успішно додано до архіву' });
        refetch();
      } else {
        const dataError = extractDataError(res.errors);
        pushMessage({ text: dataError });
      }
    },
  });

  if (loading) return <Loading />;

  return (
    <>
      <h2>{t`Редагувати спортсмена: ${data.fullName}`}</h2>
      <Paper>
        <Box m={4}>
          <BaseForm
            loading={submitLoading}
            initial={getInitialData(data)}
            onSubmit={(formData) => onSubmit(getPostData(formData))}
            errors={errors}
            edit
            showPasswordField={false}
            userId={id}
            athlete={data}
            onBlock={(reason, blockExpireAt) =>
              blockAthlete({ variables: { id, reason, blockExpireAt } })
            }
            onActivate={activateAthlete}
            onArchivate={(reason) =>
              archivateAthlete({ variables: { id, reason } })
            }
            refetchAthlete={refetch}
          />
        </Box>
      </Paper>
    </>
  );
};

export const CreateForm = () => {
  const { history } = useRouter();
  const searchParams = new URLSearchParams(history.location.search);
  const trainerId = Number(searchParams.get('trainer_id'));
  const groupId = Number(searchParams.get('group_id'));
  const section = Number(searchParams.get('section'));
  const api = useApi();
  const { user } = useUser();
  const navigate = useNavigator();
  const nextPage = new URLSearchParams(location.search).get('next');
  const pushMessage = useNotifier();
  const { loading, onSubmit, errors, submitLoading } = useCreateForm({
    schema: api.schema.athletes,
    router: api.router.athletes,
    onComplete: () => {
      pushMessage({ text: 'Успішно збережено' });
      if (nextPage) {
        navigate(nextPage);
      }
    },
  });
  if (loading) return <Loading />;
  return (
    <>
      <h2>{t`Додати спортсмена`}</h2>
      <Paper>
        <Box m={4}>
          <BaseForm
            loading={submitLoading}
            initial={getInitialData({
              clubId: user.club.id,
              trainerIds: [trainerId],
              mainTrainerId: trainerId,
              groupId: groupId,
              sections: [section],
            })}
            onSubmit={(formData) => onSubmit(getPostData(formData))}
            errors={errors}
            edit={false}
            showPasswordField={false}
          />
        </Box>
      </Paper>
    </>
  );
};
